import config from '~/config';

export const titleInfoList = [
    {
        id: 1,
        title: 'Service',
        path: config.routes.spa,
    },
    {
        id: 2,
        title: 'Product',
        path: config.routes.products,
    },
    {
        id: 3,
        title: 'Recharge card',
        path: config.routes.topUp,
    },
    // {
    //     id: 3,
    // title: 'Payment security policy',
    //     path: config.routes.policy,
    // },
    // {
    //     id: 3,
    // title: 'Contact',
    //     path: config.routes.contact,
    // },
];
